import { BASE_SERVICE_URL } from '../../../lib/constants'
import type SFTP from '../interface/sftpIntegration';

const update = async (sftp: SFTP): Promise<void> => {
    
    try {
        return await fetch(BASE_SERVICE_URL + `/sftp`, {
            credentials: 'same-origin',
            method: 'PUT',
            body:JSON.stringify(sftp),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        })

    } catch (error) {

    }
}



export default update